// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","load8":"Loader_load8__5xhlQ"};